// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"e42b4ab1","166":"dbe0e6f7","178":"e7553a58","223":"4b51fd42","291":"444a445b","439":"8601d43a","810":"bbaa737a","867":"48327de8","950":"9c9beec4"}[chunkId] + ".chunk.js";
};